import {Pipe, PipeTransform} from '@angular/core';
import {Payment, ShippingOption} from "../models/payment/paymentOrder.model";

@Pipe({
	name: 'partialSum'
})
export class PartialSumPipe implements PipeTransform {

	transform(payment: Payment, shippingMethod: ShippingOption ): number {
		if (payment) {
			let total = 0;

			payment.order.invoicePositions.forEach(position => {
				total += (position.nettoPrice * position.amount);
			});
			if (shippingMethod) {
				total = total + shippingMethod.nettoPrice;
			}
			return total;
		} else {
			return 0;
		}
	}

}
